import React from "react";
import { connect } from "react-redux";
import { push as changeURL } from "react-router-redux";

import mapDispatch from "~/misc/mapDispatch";
import { changShowCardAction } from "../../state/action";
import { POSTTRUCKSHOWTYPE } from "../../utils";

import css from "./style.css";

const showContext = {
  [POSTTRUCKSHOWTYPE.GUID_NOPOST]: {
    title: "No posting yet.",
    subTitle:
      "Post your capacity now to increase your exposure to more brokers and loads.",
    imgUrl: "../../../../../assets/posttruck/nopost.svg",
  },
  [POSTTRUCKSHOWTYPE.GUID_NOVERIFY]: {
    title: "No Verify yet.",
    subTitle:
      "Verify your email, phone number, and DOT to start posting your trucks and receive matching loads.",
    imgUrl: "../../../../../assets/posttruck/noverify.svg",
  },
};

class GuidCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showType: props.type || "GUID_NOPOST", // GUID_NOVERIFY
      content: showContext[props.type || "GUID_NOPOST"],
    };
  }
  componentWillMount() {}
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    if (this.props.user.id !== nextProps.user.id) {
      nextProps.user.emailVerified &&
        nextProps.user.verified_phone &&
        nextProps.user.dot_verified &&
        nextProps.user.mc_verified &&
        this.props.changeShowCard(POSTTRUCKSHOWTYPE.LIST);
    }
  }
  goto(type) {
    switch (type) {
      case POSTTRUCKSHOWTYPE.GUID_NOPOST:
        this.props.changeShowCard(POSTTRUCKSHOWTYPE.DETAIL_CREATE);
        break;
      case POSTTRUCKSHOWTYPE.GUID_NOVERIFY:
        this.props.isFree
          ? this.props.goto("/free-account")
          : this.props.goto("/my-account");
        break;
      default:
        break;
    }
  }
  render() {
    const { showType, content } = this.state;

    const GuidButton = () => {
      switch (showType) {
        case POSTTRUCKSHOWTYPE.GUID_NOPOST:
          return (
            <button className={css.gcBtn} onClick={() => this.goto(showType)}>
              <span className={css.gcBtnPlus}>+</span>
              <span>Post Truck</span>
            </button>
          );
        case POSTTRUCKSHOWTYPE.GUID_NOVERIFY:
          return (
            <button className={css.gcBtn} onClick={() => this.goto(showType)}>
              <span>Verify</span>
            </button>
          );
        default:
          break;
      }
    };

    return (
      <section className={css.guidCard}>
        <div className={css.gcImg}>
          <img src={content.imgUrl} alt={content.imgUrl} />
        </div>
        <div className={css.gcText}>
          <p className={css.title}>{content.title}</p>
          <p className={css.subTitle}>{content.subTitle}</p>
        </div>
        <div className={css.gcBtns}>
          <GuidButton />
        </div>
      </section>
    );
  }
}
export default connect(
  (state, ownProps) => {
    const { free, accountLevel } = state.account;
    const isFree = Number(accountLevel) <= Number(free);
    return {
      user: state.user,
      ...ownProps,
      isFree,
    };
  },
  mapDispatch({
    goto: (props, url) => changeURL(url),
    changeShowCard: (props, type) => changShowCardAction(type),
  })
)(GuidCard);



// WEBPACK FOOTER //
// ./src/pages/PostTruck/compontents/GuideCard/index.js